import { css } from '@/styled-system/css';

export const photoCarouselSlidesStyles = css.raw({
  'display': 'flex',
  'flex': 1,
  'position': 'relative',
  'zIndex': 0,
  'height': '100%',
  'touchAction': 'pan-y' /* CDS-3106: Prevent horizontal browser scrolling */,
  'transition': {
    _motionReduce: 'none',
    _motionSafe: '{transform 0.2s cubic-bezier(0.58, 0.92, 0.57, 0.92)}',
  },

  '@media (hover: none)': {
    transform: 'translate3d(0, 0, 0)',
  },
});
